import api from './index';
import { getToken } from '../utils/authUtils';
import { IUser } from '../types/User.interface';
import { UserName } from '@callmart/types';

const BASE = '/user';

export const getAllUsers = async (withHemtUsers: boolean = false) => {
    return api
        .get<UserName[]>(BASE, {
            params: withHemtUsers ? { all: true } : {},
        })
        .then((res) => res.data);
};

/*
 * Fetches the user information from the backend. Could be used to get the current user's info or any user info if a token is provided.
 */
export const getUserInfo = async (token?: string) => {
    token = token || getToken();
    return api.get<IUser>(`${BASE}/me`, { headers: { Authorization: `Bearer ${token}` } }).then((res) => res.data);
};
